module.exports = __webpack_public_path__ + "static/img/mh-2.6ad1da49.png";